import React from 'react';
import { FadeIn } from './FadeIn';
export const HowItWorksSection = () => {
  const steps = [{
    num: '01',
    title: 'Identificas la carga',
    desc: 'Localizamos el trauma y el patrón repetitivo.'
  }, {
    num: '02',
    title: 'Limpias el canal',
    desc: 'Aplicas el colapso consciente para entrar en el Vacío.'
  }, {
    num: '03',
    title: 'Saltas de línea',
    desc: "Sintonizas la frecuencia de tu versión 'Renacida' y la anclas en tu biología."
  }];
  return <section className="py-32 px-4 relative border-t border-sand bg-parchment-dark/30" data-id="element-118">
      <div className="max-w-5xl mx-auto" data-id="element-119">
        <FadeIn data-id="element-120">
          <h2 className="font-playfair text-4xl md:text-5xl font-bold text-center mb-20 text-brown-espresso" data-id="element-121">
            Cómo <span className="gold-gradient-text" data-id="element-122">Funciona</span>
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative" data-id="element-123">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-1/6 right-1/6 h-px bg-gradient-to-r from-transparent via-sand-dark to-transparent z-0" data-id="element-124"></div>

          {steps.map((step, index) => <FadeIn key={index} delay={0.2 * (index + 1)} className="relative z-10" data-id="element-125">
              <div className="flex flex-col items-center text-center group" data-id="element-126">
                <div className="w-24 h-24 rounded-full bg-parchment border border-gold/30 flex items-center justify-center mb-8 shadow-[0_0_30px_rgba(184,146,46,0.08)] group-hover:border-gold-antique group-hover:shadow-[0_0_40px_rgba(184,146,46,0.2)] transition-all duration-500" data-id="element-127">
                  <span className="font-playfair text-3xl font-bold text-gold-antique" data-id="element-128">
                    {step.num}
                  </span>
                </div>
                <h3 className="text-xl font-semibold text-brown-heading mb-4" data-id="element-129">
                  {step.title}
                </h3>
                <p className="text-brown-warm/70 leading-relaxed" data-id="element-130">
                  {step.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
};